import { axios } from 'apis';
import { CustomerStatistics, MonthlyStatistics, QuickStatusData, WeeklyStatistics } from 'models';

const ENDPOINT = 'Statistics';
export const StatisticsService = {
	quickStatusData: async () => {
		const response = await axios.get(`${ENDPOINT}/QuickStatusData`);
		return (await response.data) as QuickStatusData;
	},
	getWeeklyStatistics: async (selectedWeek: number) => {
		const response = await axios.get(`${ENDPOINT}/WeeklyStatistics/${selectedWeek}`);
		return (await response.data) as WeeklyStatistics;
	},
	getMonthlyStatistics: async (selectedMonth: number) => {
		const response = await axios.get(`${ENDPOINT}/MonthlyStatistics/${selectedMonth}`);
		return (await response.data) as MonthlyStatistics;
	},
	getCustomersStatistics: async (customerId: number) => {
		const response = await axios.get(`${ENDPOINT}/CustomersStatistics/${customerId}`);
		return (await response.data) as CustomerStatistics;
	},
};